import { XStack, Text } from "tamagui";
import { LinearGradient } from "@tamagui/linear-gradient";
import { defaultTo } from "lodash";
import { Platform } from "./XPReactNative.mjs";
import { jsx } from "react/jsx-runtime";
const XPProgressBar = props => {
  const {
    value
  } = props;
  const zeroPosition = Math.min(Math.max(0, defaultTo(props.zeroPosition, 0)), 100);
  const zeroPositionRemainder = 100 - zeroPosition;
  const percentForProgressbar = Math.round(Math.min(100, zeroPosition + zeroPositionRemainder * (value / 100)));
  const primaryColor = defaultTo(props.primaryColor, "#272727");
  const secondaryColor = defaultTo(props.secondaryColor, primaryColor);
  const backgroundGradient = `linear-gradient(to right, ${secondaryColor}, ${primaryColor})`;
  const progressBarStyleProps = {
    height: "100%",
    width: percentForProgressbar + "%",
    alignItems: "center",
    background: Platform.select({
      web: backgroundGradient,
      native: primaryColor
    })
  };
  const height = defaultTo(props.height, 26);
  const backgroundColor = defaultTo(props.backgroundColor, "rgb(240, 240, 240)");
  const defaultChild = /* @__PURE__ */jsx(Text, {
    children: "\xA0"
  });
  const children = defaultTo(props.children, defaultChild);
  const backgroundStyleProps = {
    justifyContent: "flex-start",
    overflow: "hidden",
    height,
    backgroundColor
  };
  if (props.borderRadius) {
    backgroundStyleProps["borderRadius"] = props.borderRadius;
  }
  return /* @__PURE__ */jsx(XStack, {
    style: backgroundStyleProps,
    children: /* @__PURE__ */jsx(LinearGradient, {
      width: percentForProgressbar + "%",
      height: "100%",
      ...defaultTo({
        rounded: props.borderRadius
      }, {}),
      style: {
        display: "flex",
        alignItems: "center"
      },
      alignItems: "center",
      colors: [secondaryColor, primaryColor],
      start: [0, 0],
      end: [1, 0],
      children
    })
  });
};
export { XPProgressBar };
//# sourceMappingURL=XPProgressBar.mjs.map
